import axios from 'axios'

export default {
  fetchUser () {
    return axios.get('/api/user')
  },
  updateUser (payload) {
    // For FormData, use POST with _method override since PATCH with FormData can be problematic
    if (payload instanceof FormData) {
      // FormData already has _method: PATCH appended in the component
      return axios.post('/api/user', payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    }
    // For regular JSON payload, use PATCH
    return axios.patch('/api/user', payload)
  },
  updateAddress (addressId, payload) {
    return axios.patch(`/api/address/${addressId}/update`, payload)
  },
  addUser (payload) {
    return axios.post('/api/user', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  register (payload) {
    return axios.post('/api/register', payload)
  },
  login (payload) {
    return axios.post('/api/login', payload)
  },
  verifyEmail (id, query) {
    return axios.post(`/api/email/verify/${id}?${query}`)
  },
  resendEmail (payload) {
    return axios.post('/api/email/resend', payload)
  },
  sendEmail (payload) {
    return axios.post('/api/password/email', payload)
  },
  logout () {
    return axios.post('/api/logout')
  },
  fetchOAuthUrl (provider) {
    return axios.post(`/api/oauth/${provider}`)
  },
  registerWholesaleAccount (payload) {
    return axios.post('/api/signup', payload)
  },
  resetPassword (password) {
        return axios.patch('/api/user/password', password)
  },
  loginAsUser (payload) {
        return axios.post('/api/login-as', payload)
  },
  updatePassword (payload) {
        return axios.patch('/api/user/password', payload)
  },
  hideWholesalePrice () {
    return axios.post('/api/user/hide-wholesale-price')
  },
  showWholesalePrice (password) {
    return axios.post('/api/user/show-wholesale-price', { password })
  },
  updateUiPreference (payload) {
    return axios.patch('/api/user/preferences', payload)
  },
}
